(function () {
  const modal = document.querySelector('[data-sales-rep-quick-add]');
  if (!modal) return;

  const DATA_SELECTOR = '[data-sales-rep-data]';
  const DEFAULT_STATUS = 'Select your state to view your representative.';
  const UNAVAILABLE_STATUS =
    'Representative lookup is unavailable. Please try again later.';
  const TRIGGER_SELECTOR =
    '.mp-hide-price-call-button-link, .mp-hide-price-call-button, [data-sales-rep-trigger], #contact-rep-trigger';
  const GLOBAL_TRIGGER_SELECTOR = '[data-sales-rep-trigger], #contact-rep-trigger';
  const GRID_SELECTOR = '#ProductGridContainer';

  // Postal code to the label shown in the state select. Reference data, so it
  // covers every state rather than only the ones currently assigned - a rep
  // gaining a new state then needs no code change.
  const POSTAL_TO_STATE = {
    AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas',
    CA: 'California', CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware',
    DC: 'District of Columbia', FL: 'Florida', GA: 'Georgia', HI: 'Hawaii',
    ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', IA: 'Iowa', KS: 'Kansas',
    KY: 'Kentucky', LA: 'Louisiana', ME: 'Maine', MD: 'Maryland',
    MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota', MS: 'Mississippi',
    MO: 'Missouri', MT: 'Montana', NE: 'Nebraska', NV: 'Nevada',
    NH: 'New Hampshire', NJ: 'New Jersey', NM: 'New Mexico', NY: 'New York',
    NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio', OK: 'Oklahoma',
    OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island',
    SC: 'South Carolina', SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas',
    UT: 'Utah', VT: 'Vermont', VA: 'Virginia', WA: 'Washington',
    WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming',
    // One country-wide option, keyed CAN because CA is already California.
    CAN: 'Canada',
  };
  // Listed first; alphabetically it would sit between California and Colorado.
  const PINNED_POSTAL = 'CAN';

  const dialog = modal.querySelector('.sales-rep-quick-add__dialog');
  const stateSelect = modal.querySelector('[data-sales-rep-state]');
  const statusEl = modal.querySelector('[data-sales-rep-status]');
  const repList = modal.querySelector('[data-sales-rep-list]');
  const productImage = modal.querySelector('[data-sales-rep-product-image]');
  const productTitle = modal.querySelector('[data-sales-rep-product-title]');
  const descriptionEl = modal.querySelector('#SalesRepQuickAddDescription');
  const defaultDescription = descriptionEl ? descriptionEl.textContent.trim() : '';
  const titleEl = modal.querySelector('#SalesRepQuickAddTitle');
  const defaultTitle = titleEl ? titleEl.textContent.trim() : '';
  let repsData = [];
  let directRepsByCollection = new Map();
  let repsRequest = null;
  let lastFocusedElement = null;
  let activeTrigger = null;
  let snapshotRequest = null;
  let snapshotUrl = null;

  function getText(element) {
    return element ? element.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function dismissNativeCallPopup() {
    document.querySelectorAll('.mp-call-popup-show').forEach((popup) => {
      popup.classList.remove('mp-call-popup-show');
    });
  }

  function setStatus(message) {
    statusEl.textContent = message;
  }

  function clearRepList() {
    repList.replaceChildren();
  }

  function disableSelect() {
    stateSelect.disabled = true;
    stateSelect.options[0].textContent = 'Unavailable';
  }

  function populateStates() {
    const selectedValue = stateSelect.value;
    const firstOption = stateSelect.options[0];
    stateSelect.replaceChildren(firstOption);

    const statesByPostal = new Map();
    repsData.forEach((rep) => {
      const label = POSTAL_TO_STATE[rep.Postal];
      if (label && !statesByPostal.has(rep.Postal)) {
        statesByPostal.set(rep.Postal, label);
      }
    });

    Array.from(statesByPostal.entries())
      .sort(
        (first, second) =>
          (second[0] === PINNED_POSTAL) - (first[0] === PINNED_POSTAL) ||
          first[1].localeCompare(second[1])
      )
      .forEach(([postal, state]) => {
        const option = document.createElement('option');
        option.value = postal;
        option.textContent = state;
        stateSelect.appendChild(option);
      });

    if (statesByPostal.has(selectedValue)) {
      stateSelect.value = selectedValue;
    }
  }

  // Splits one metaobject-shaped rep into the flat, state-keyed records the
  // rest of the widget already expects, so a rep covering twelve states still
  // produces twelve rows and a state with two reps still returns both.
  function toStateRecords(rep) {
    const states = Array.isArray(rep.states) ? rep.states : [];
    const base = {
      Rep: rep.name,
      'Image URL': rep.image || '',
      Position: rep.position || '',
      'Phone number': rep.phone || '',
      email: rep.email || '',
      // How many states this rep covers, used only to order a state's results:
      // the narrower the territory the more local the rep, so a regional rep
      // lists above someone carrying the whole country.
      coverage: states.length,
    };
    return states.map((postal) => Object.assign({ Postal: postal }, base));
  }

  function readEmbeddedReps() {
    const node = document.querySelector(DATA_SELECTOR);
    if (!node) return null;
    try {
      const parsed = JSON.parse(node.textContent);
      return Array.isArray(parsed) ? parsed : null;
    } catch (error) {
      console.error('Error parsing reps data:', error);
      return null;
    }
  }

  // Kept promise-returning so the open path's ordering is unchanged, even
  // though the data is now present at parse time.
  function loadReps() {
    if (repsRequest) return repsRequest;

    repsRequest = new Promise((resolve) => {
      const reps = readEmbeddedReps();

      if (!reps || !reps.length) {
        disableSelect();
        setStatus(UNAVAILABLE_STATUS);
        resolve();
        return;
      }

      repsData = reps.reduce(
        (records, rep) => records.concat(toStateRecords(rep)),
        []
      );

      directRepsByCollection = new Map();
      reps.forEach((rep) => {
        const handles = Array.isArray(rep.collections) ? rep.collections : [];
        handles.forEach((handle) => {
          directRepsByCollection.set(handle, {
            Rep: rep.name,
            'Image URL': rep.image || '',
            Position: rep.position || '',
            'Phone number': rep.phone || '',
            email: rep.email || '',
          });
        });
      });

      populateStates();
      if (!applyDirectRep()) {
        setStatus(DEFAULT_STATUS);
      }
      resolve();
    });

    return repsRequest;
  }

  function getProductDetails(trigger) {
    if (trigger.dataset && trigger.dataset.productTitle) {
      return {
        title: trigger.dataset.productTitle,
        imageSrc: trigger.dataset.productImage || '',
        imageAlt: trigger.dataset.productTitle,
      };
    }

    // Legacy PDP tiles are not product cards; their ancestors' images are UI icons.
    const isLegacyPdpTrigger = trigger.matches('#contact-rep-trigger, #contact-rep-trigger *');
    const card = isLegacyPdpTrigger ? null : trigger.closest('.grid__item, .card-wrapper, li');
    const titleElement =
      card &&
      (card.querySelector('.card__heading a') ||
        card.querySelector('.card__heading') ||
        card.querySelector('.full-unstyled-link') ||
        card.querySelector('a[href*="/products/"]'));
    const imageElement =
      card &&
      (card.querySelector('.card__media img') ||
        card.querySelector('.media img') ||
        card.querySelector('img'));

    let title = getText(titleElement);
    let resolvedImageElement = imageElement;

    if (!title) {
      const pdpTitleElement = document.querySelector('.product__title h1, h1.product__title');
      const pdpTitle = getText(pdpTitleElement);

      if (pdpTitle) {
        title = pdpTitle;
        resolvedImageElement = document.querySelector('.product__media img');
      }
    }

    title = title || 'Product pricing';
    const imageSrc = resolvedImageElement
      ? resolvedImageElement.currentSrc || resolvedImageElement.src
      : '';
    const imageAlt = resolvedImageElement ? resolvedImageElement.alt || title : title;

    return { title, imageSrc, imageAlt };
  }

  function setProductPreview(details) {
    productTitle.textContent = details.title;

    if (details.imageSrc) {
      productImage.src = details.imageSrc;
      productImage.alt = details.imageAlt;
      productImage.hidden = false;
    } else {
      productImage.removeAttribute('src');
      productImage.alt = '';
      productImage.hidden = true;
    }
  }

  function getInitials(name) {
    return (name || 'CM')
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part.charAt(0))
      .join('')
      .toUpperCase();
  }

  function createFallbackAvatar(name) {
    const fallback = document.createElement('span');
    fallback.className = 'sales-rep-quick-add__rep-fallback';
    fallback.setAttribute('aria-hidden', 'true');
    fallback.textContent = getInitials(name);
    return fallback;
  }

  function createRepCard(rep) {
    const group = document.createElement('div');
    group.className = 'sales-rep-quick-add__rep-group';

    const card = document.createElement('article');
    card.className = 'sales-rep-quick-add__rep';

    const name = rep.Rep || 'Catchmaster Pro Representative';
    const imageUrl = rep['Image URL'];

    if (imageUrl) {
      const image = document.createElement('img');
      image.className = 'sales-rep-quick-add__rep-image';
      image.src = imageUrl;
      image.alt = name;
      image.width = 72;
      image.height = 72;
      image.loading = 'lazy';
      image.addEventListener('error', () => {
        image.replaceWith(createFallbackAvatar(name));
      });
      card.appendChild(image);
    } else {
      card.appendChild(createFallbackAvatar(name));
    }

    const copy = document.createElement('div');
    copy.className = 'sales-rep-quick-add__rep-copy';

    const heading = document.createElement('h4');
    heading.textContent = name;
    copy.appendChild(heading);

    if (rep.Position) {
      const position = document.createElement('p');
      position.textContent = rep.Position;
      copy.appendChild(position);
    }

    const actions = document.createElement('div');
    actions.className = 'sales-rep-quick-add__rep-actions';

    const hidePhone = activeTrigger && activeTrigger.hasAttribute('data-rep-hide-phone');
    if (rep['Phone number'] && !hidePhone) {
      const phone = document.createElement('a');
      phone.href = `tel:${String(rep['Phone number']).replace(/[^\d+]/g, '')}`;
      phone.textContent = `Call: ${rep['Phone number']}`;
      actions.appendChild(phone);
    }

    const recipient = (activeTrigger && activeTrigger.getAttribute('data-rep-email-to')) || rep.email;
    if (recipient) {
      const email = document.createElement('a');
      email.href = `mailto:${recipient}${mailtoPrefill(rep)}`;
      email.textContent = `Email: ${recipient}`;
      actions.appendChild(email);
    }

    card.appendChild(copy);
    group.appendChild(card);

    if (actions.children.length) {
      group.appendChild(actions);
    }

    return group;
  }

  // Opt-in, per trigger: a page that wants a prefilled enquiry declares the
  // subject and body on its own trigger, so every other trigger in the store
  // keeps producing a plain mailto: link.
  function mailtoPrefill(rep) {
    if (!activeTrigger) return '';
    const subject = activeTrigger.getAttribute('data-rep-email-subject');
    if (!subject) return '';
    const rawBody = activeTrigger.getAttribute('data-rep-email-body') || '';
    // Accept either a real newline from the setting or a literal backslash-n,
    // so the body survives however the attribute was authored. A raw newline
    // left in the href itself is dropped by several mail clients, which is why
    // encodeURIComponent below is what actually makes the line breaks work.
    let body = rawBody.replace(/\\n/g, '\n');
    const state = POSTAL_TO_STATE[stateSelect.value];
    if (state) body = `${body ? body.replace(/\n*$/, '\n') : ''}State: ${state}\n`;
    // mailto: carries plain text only, so the preview image travels on the
    // clipboard and the body marks where it is pasted.
    if (snapshotRequest) body += '\nLogo preview (paste here):\n';
    let query = `?subject=${encodeURIComponent(rep && rep.Rep ? `${subject} - ${rep.Rep}` : subject)}`;
    if (body) query += `&body=${encodeURIComponent(body)}`;
    return query;
  }

  function currentCollectionHandle() {
    const match = window.location.pathname.match(/\/collections\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  // Every collection handle this page could be scoped by, most specific first:
  // the one in the URL, then - on a product page, which has no collection in
  // its path - the collections the product itself belongs to.
  function candidateCollectionHandles() {
    const handles = [];
    const fromUrl = currentCollectionHandle();
    if (fromUrl) handles.push(fromUrl);

    const attr = modal.getAttribute('data-sales-rep-product-collections') || '';
    attr.split(',').forEach((handle) => {
      const trimmed = handle.trim();
      if (trimmed && handles.indexOf(trimmed) === -1) handles.push(trimmed);
    });

    return handles;
  }

  // First match wins. Today only one rep carries collections, so the order is
  // not load-bearing; if a second rep is ever scoped to a collection a product
  // also sits in, the URL's collection decides, then the product's own order.
  function directRepForPage() {
    const handles = candidateCollectionHandles();
    for (let i = 0; i < handles.length; i += 1) {
      const rep = directRepsByCollection.get(handles[i]);
      if (rep) return rep;
    }
    return null;
  }

  // Returns true when this collection is handled by one named rep instead of
  // the state selector. Which collections those are is now merchant-editable:
  // it comes from each rep's `collections` field, not from a map in this file.
  function applyDirectRep() {
    const label = modal.querySelector('.sales-rep-quick-add__label');
    const selectWrap = modal.querySelector('.sales-rep-quick-add__select-wrap');
    if (label) label.hidden = false;
    if (selectWrap) selectWrap.hidden = false;
    // Restored rather than hidden: it is the dialog's aria-describedby target.
    if (descriptionEl) descriptionEl.textContent = defaultDescription;

    const rep = directRepForPage();
    if (!rep) return false;

    if (label) label.hidden = true;
    if (selectWrap) selectWrap.hidden = true;
    if (descriptionEl) {
      descriptionEl.textContent =
        'This product range is handled by a dedicated representative.';
    }
    clearRepList();
    setStatus(`Your representative for this range is ${rep.Rep}.`);
    repList.appendChild(createRepCard(rep));
    return true;
  }

  function showSelectedReps() {
    const selectedState = stateSelect.value;
    clearRepList();

    if (!selectedState) {
      setStatus(DEFAULT_STATUS);
      return;
    }

    const reps = repsData
      .filter((rep) => rep.Postal === selectedState)
      .sort(
        (first, second) =>
          first.coverage - second.coverage || first.Rep.localeCompare(second.Rep)
      );

    if (!reps.length) {
      setStatus('No representative was found for that state. Please select another state.');
      return;
    }

    setStatus(`${reps.length} representative${reps.length === 1 ? '' : 's'} found.`);
    reps.forEach((rep) => repList.appendChild(createRepCard(rep)));
  }

  function getFocusableElements() {
    return Array.from(
      modal.querySelectorAll(
        'a[href], button:not([disabled]), select:not([disabled]), textarea:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((element) => {
      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    });
  }

  function openModal(trigger) {
    dismissNativeCallPopup();
    activeTrigger = trigger;
    // Rendered on open, not on the Email click: by then the mail app is taking
    // focus, and a clipboard write from an unfocused page is rejected.
    snapshotRequest =
      typeof PrivateLabelCustomizer === 'function' && PrivateLabelCustomizer.snapshot
        ? PrivateLabelCustomizer.snapshot(trigger)
        : null;
    if (snapshotRequest) snapshotRequest.catch(() => {});
    lastFocusedElement = document.activeElement;
    // A page that drops the phone numbers can retitle the modal, so it does not
    // promise a call it no longer offers.
    if (titleEl) titleEl.textContent = trigger.dataset.repTitle || defaultTitle;
    setProductPreview(getProductDetails(trigger));
    showSnapshot(snapshotRequest);
    // A trigger with no product behind it, like a page-level CTA, can drop the
    // image box instead of showing it empty.
    modal.toggleAttribute('data-rep-no-image', trigger.hasAttribute('data-rep-hide-image'));
    clearRepList();
    stateSelect.value = '';
    // The data is rendered with the page, so an empty set means it is missing,
    // never that it is still on its way.
    setStatus(repsData.length ? DEFAULT_STATUS : UNAVAILABLE_STATUS);

    modal.hidden = false;
    document.body.classList.add('sales-rep-quick-add-lock');
    activeTrigger.setAttribute('aria-expanded', 'true');
    dialog.focus({ preventScroll: true });
    loadReps().then(applyDirectRep);
  }

  function closeModal() {
    if (modal.hidden) return;

    dismissNativeCallPopup();
    modal.hidden = true;
    document.body.classList.remove('sales-rep-quick-add-lock');

    if (activeTrigger) activeTrigger.setAttribute('aria-expanded', 'false');
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus({ preventScroll: true });
    }

    activeTrigger = null;
    snapshotRequest = null;
    lastFocusedElement = null;
    releaseSnapshotUrl();
  }

  // The modal shows the same product-with-logo image that is copied for the
  // email. The plain product photo stays until it is rendered, and stays for
  // good if rendering fails.
  function showSnapshot(request) {
    releaseSnapshotUrl();
    if (!request) return;
    request
      .then((blob) => {
        if (request !== snapshotRequest) return;
        snapshotUrl = URL.createObjectURL(blob);
        productImage.src = snapshotUrl;
        productImage.hidden = false;
      })
      .catch(() => {});
  }

  function releaseSnapshotUrl() {
    if (!snapshotUrl) return;
    URL.revokeObjectURL(snapshotUrl);
    snapshotUrl = null;
  }

  // Copies the preview before the draft opens. The write is started inside the
  // click so Safari counts it as user-initiated; the draft opens either way.
  function copySnapshotThenOpen(event) {
    const link = event.target.closest('a[href^="mailto:"]');
    if (!link || !snapshotRequest || !navigator.clipboard || !window.ClipboardItem) return;
    event.preventDefault();
    navigator.clipboard
      .write([new ClipboardItem({ 'image/png': snapshotRequest })])
      .then(() => setStatus('Logo preview copied. Paste it into your email.'))
      .catch(() => {})
      .finally(() => {
        window.location.href = link.href;
      });
  }

  function enhanceTriggers(root) {
    root.querySelectorAll(TRIGGER_SELECTOR).forEach((trigger) => {
      const link = trigger.classList.contains('mp-hide-price-call-button-link')
        ? trigger
        : trigger.closest('.mp-hide-price-call-button-link');
      const enhancedTarget = link || trigger;

      enhancedTarget.setAttribute('aria-haspopup', 'dialog');
      enhancedTarget.setAttribute('aria-controls', 'SalesRepQuickAdd');
      enhancedTarget.setAttribute('aria-expanded', 'false');

      if (trigger.tagName === 'BUTTON') {
        trigger.type = 'button';
        trigger.setAttribute('aria-label', 'Contact a Sales Rep. Find your representative.');
      }
    });
  }

  function replaceCallForPriceCopy(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const textNodes = [];

    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    textNodes.forEach((textNode) => {
      if (/call\s+for\s+price/i.test(textNode.nodeValue)) {
        textNode.nodeValue = textNode.nodeValue.replace(/call\s+for\s+price/gi, 'Contact a Sales Rep');
      }
    });

    root.querySelectorAll('[aria-label], [title]').forEach((element) => {
      ['aria-label', 'title'].forEach((attribute) => {
        const value = element.getAttribute(attribute);
        if (value && /call\s+for\s+price/i.test(value)) {
          element.setAttribute(attribute, value.replace(/call\s+for\s+price/gi, 'Contact a Sales Rep'));
        }
      });
    });
  }

  function handleCallTriggerClick(event) {
    const trigger = event.target.closest(TRIGGER_SELECTOR);

    if (trigger && (trigger.matches(GLOBAL_TRIGGER_SELECTOR) || trigger.closest(GRID_SELECTOR))) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openModal(trigger);
    }
  }

  document.addEventListener('click', handleCallTriggerClick, true);

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-sales-rep-close]')) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (modal.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusableElements = getFocusableElements();
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (!firstElement || !lastElement) {
      event.preventDefault();
      return;
    }

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  });

  stateSelect.addEventListener('change', showSelectedReps);
  repList.addEventListener('click', copySnapshotThenOpen);

  enhanceTriggers(document);
  replaceCallForPriceCopy(document);
  loadReps();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          enhanceTriggers(node);
          replaceCallForPriceCopy(node);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
